import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Navigation } from "@orion2/models/tocitem.models";
import { Store } from "@viewer/core";
import { OrionCardSource } from "@viewer/shared-module/orion-card/pipe/orion-card.pipe";

@Component({
  standalone: false,
  selector: "o-navigation-tree",
  templateUrl: "./navigation-tree.component.html",
  styleUrls: ["./navigation-tree.component.scss"]
})
export class NavigationTreeComponent implements OnInit {
  @Input() navigation: Navigation;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClick: EventEmitter<Navigation> = new EventEmitter();

  public readonly orionCardSource = OrionCardSource;
  public dmcSelected: string;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.dmcSelected = this.store.currentDMC;
  }

  emitClose(item: Navigation): void {
    this.onClick.emit(item);
  }

  public toggle(item: Navigation): void {
    item.active = !item.active;
  }
}
